<template>
    <v-layout row justify-center v-if="visible">
        <v-card elevation="0" style="max-width: 1000px;">
            <v-card-title>
                <h3>{{ $t("bandSaw") }}</h3>
            </v-card-title>
            <v-card-text>
                 <v-layout wrap>
                    <v-flex xs12 sm3>
                        <v-layout wrap>
                            <v-flex xs12 sm8 pa-2>
                                <v-text-field
                                    :label="$t('kerf')"
                                    :hint="`${$t('kerf')}, ${$t('mm')}`"
                                    :suffix="$t('mm')"
                                    :rules="[rules.required, rules.kerf]"
                                    @change="changeHandler"
                                    v-model="kerf.val"
                                    ref="kerf"
                                    required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-divider vertical class="mx-2"></v-divider>
                    <v-flex xs12 sm4 pa-1>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-checkbox
                                    v-model="trimSideBoards"
                                    :label="$t('sideBoardsSawing')"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 pa-2>
                                <v-text-field
                                :label="`${$t('maxSideBoardsAmount')}`"
                                :hint="`${$t('maxSideBoardsAmount')}`"
                                :rules="[rules.required, rules.maxSideBoardsAmount]"
                                @change="changeHandler"
                                v-model="maxSideBoardsAmount.val"
                                ref="maxSideBoardsAmount"
                                required
                                :disabled="!trimSideBoards"
                                hide-details
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-checkbox
                                    v-model="splitSides"
                                    :label="$t('boardsCuttingPossibility')"
                                    :disabled="!trimSideBoards"
                                    hide-details
                                ></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-divider vertical class="mx-2"></v-divider>
                    <v-flex xs12 sm4 pa-1>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-checkbox
                                    v-model="trimCentralPattern"
                                    :label="$t('centralHalfTimberSawing')"
                                ></v-checkbox>
                            </v-flex>
                            <v-flex xs12>
                                <v-checkbox
                                    v-model="splitCentral"
                                    :label="$t('boardsCuttingPossibility')"
                                    :disabled="!trimCentralPattern"
                                    hide-details
                                ></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-divider vertical class="ml-3"></v-divider>
                 </v-layout>
            </v-card-text>
        </v-card>
    </v-layout>
</template>

<script>
    export default {
        name: "BandSawSettings",

        data () {
            return {
                changed:       false,
                checkingInput: false,
                disableWatch:  false,
                kerf:          { val: 0, min: 0, max: 0 },
                maxSideBoardsAmount: { val: 2, min: 0, max: 0 },
                rules: {
                    required: value => !!value || this.$t("requiredField"),
                    isNumber: value => !isNaN(value) || this.$t("incorrectValue"),
                    kerf:     value => (value >= this.kerf.min && value <= this.kerf.max) || this.$t("incorrectValue"),
                    maxSideBoardsAmount: value => (value >= this.maxSideBoardsAmount.min && value <= this.maxSideBoardsAmount.max) || this.$t("incorrectValue"),
                },
                trimSideBoards:     true,
                trimCentralPattern: false,
                splitSides:         false,
                splitCentral:       false,
                visible: false
            }
        },

        watch: {
            trimSideBoards: function () { this.changed = !this.disableWatch ? true : this.changed; },
            trimCentralPattern: function () { this.changed = !this.disableWatch ? true : this.changed; },
            splitSides: function () { this.changed = !this.disableWatch ? true : this.changed; },
            splitCentral: function () { this.changed = !this.disableWatch ? true : this.changed; },
            visible: function (val) { this.changed = val ? false : this.changed; },
        },

        methods: {
            /**
             *  Отслеживание изменений
             */
            changeHandler () {
                if (!this.disableWatch) { this.changed = true; }
            }
        }
    }
</script>
